import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class Textarea extends React.Component {
    componentDidMount() {
        if (this.props.autofocus) {
            this.input.focus();
        }
    }

    render() {
        const { invalid, inverse, autofocus, ...rest } = this.props;

        const isInversed = inverse || this.context.inverse;

        return (
            <textarea
                ref={c => (this.input = c)}
                className={classnames(
                    'formInput',
                    { 'formInput--error': invalid },
                    { 'formInput--inverse': isInversed }
                )}
                {...rest}
            />
        );
    }
}

Textarea.propTypes = {
    invalid: PropTypes.bool,
    inverse: PropTypes.bool,
    autofocus: PropTypes.bool,
    rows: PropTypes.number,
};

Textarea.defaultProps = {
    invalid: false,
    rows: 6,
};

Textarea.contextTypes = {
    inverse: PropTypes.bool,
};

export default Textarea;
